// extracted by mini-css-extract-plugin
export default {"Skeleton":"Skeleton_Skeleton__GCp6j","load":"Skeleton_load__l34fW"};